export const STATUS_OPTIONS = [
  { value: "nowe", label: "Nowe", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  { value: "w_realizacji", label: "W realizacji", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  { value: "wyslane", label: "Wysłane", cls: "bg-blue-100 text-blue-800 border-blue-300" },
  { value: "zakonczone", label: "Zakończone", cls: "bg-green-100 text-green-800 border-green-300" },
  { value: "anulowane", label: "Anulowane", cls: "bg-red-100 text-red-800 border-red-300" },
];

export const statusMeta = (value) =>
  STATUS_OPTIONS.find((s) => s.value === value) || STATUS_OPTIONS[0];

export function downloadJson(filename, data) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
